//import {DateTimeHelper} from "../../helpers/dateTime/DateTimeHelper"
import {LocalTimeRegistrationHelper} from "../../helpers/timeRegistration/LocalTimeRegistrationHelper";
import appSettings from "../config/appSettings"

export const WORK_STATE_START = 'START';
export const WORK_STATE_STOP = 'STOP';
export const WORK_STATE_IDLE = 'IDLE';

export default {
    methods:{
        buildBaseLMRADataObjectForType(object_type){
            let formData = {};
            let dataObject = {};

            formData['client_name'] = this.$store.getters.getClientName;
            formData['project_id'] = this.$store.getters.getProjectId;
            formData['location'] = JSON.stringify(this.$store.getters.getUserCurrentLocation);

            if(this.appSettings.usesProjectWorkShift){
                formData['project_shift'] = this.$store.getters.getProjectShift;
            }
            if(this.appSettings.usesProjectWorkDistance){
                formData['project_distance'] = this.$store.getters.getProjectDistance;
            }

            if(this.appSettings.usesCAPTagCodeScanner){
                formData['project_tag_code'] = this.$store.getters.getProjectTagCode;
            }

            if(LocalTimeRegistrationHelper.getWorkStateStartLockStateForUser(this.$store.getters.getUserId)){
                let currentWorkSessionId = LocalTimeRegistrationHelper.getCurrentTimeRegistrationWorkSessionIdForUser(this.$store.getters.getUserId);
                if(currentWorkSessionId !== null){
                    formData['work_session_id'] = currentWorkSessionId;
                }
            }

            dataObject['data'] = formData;
            dataObject['data_type'] = object_type;

            //CREATED_ON HAS BEEN REMOVED FORM WEB VERSION AND AUTO FILLED ON SERVER RECEIVED! SO USERS CAN't FIDDLE WITH THE TIMING

            //USE RAW ID SINCE IT'S A UNIQUE AUTH0 ID NOT LINKED TO USER CREDENTIALS OR EMAIL ADDRESS STORED ON OUR END!
            dataObject['user'] = this.$store.getters.getRawUserIdForDataTransfer;
            

            return dataObject;
        }
    },
    mixins:[appSettings]
};